<template>
    <div class="payments-credit-card">
        <div :style="loadedStyle">
            <div class="row" v-if="field.typeSettings.cardholderName===1||field.typeSettings.cardholderName==='1'">
                <div class="col col-lg-12">
                    <div class="credit-card-label" v-if="!field.label.hidden"><label>
                        <span>Cardholder Name</span>
                        <span class="required">*</span>
                    </label></div>
                    <input type="text" required :value="cardholderName" placeholder="Cardholder Name"
                    v-on:input="addCardHolderName($event.target.value)"
                    v-on:blur="addCardHolderName($event.target.value)" />
                </div>
            </div>
            <div class="row">
                <div class="col col-lg-12">
                    <div class="credit-card-label" v-if="!field.label.hidden"><label>
                        <span>Card Number</span>
                        <span class="required">*</span>
                    </label></div>
                    <div class="credit-card-input" id="card-number"></div>
                    <error-message v-if="errors.card" :serverMessage="errors.card" />
                </div>
            </div>
            <div class="row">
                <div class="col col-lg-4 credit-card-exp-column">
                    <div class="credit-card-label" v-if="!field.label.hidden"><label>
                        <span>Expiration Date</span>
                        <span class="required">*</span>
                    </label></div>
                    <div class="credit-card-input" id="card-expiry"></div>
                    <error-message v-if="errors.date" :serverMessage="errors.date" />
                </div>
                <div class="col col-lg-4 credit-card-cvc-column">
                    <div class="credit-card-label" v-if="!field.label.hidden"><label>
                        <span>CVC</span>
                        <span class="required">*</span>
                    </label></div>
                    <div class="credit-card-input" id="card-cvc"></div>
                    <error-message v-if="errors.cvc" :serverMessage="errors.cvc" />
                </div>
                <div class="col col-lg-4 credit-card-zip-column" id="card-zip">
                    <div class="credit-card-label" v-if="!field.label.hidden"><label>
                        <span>Zip/Postal Code</span>
                        <span class="required">*</span>
                    </label></div>
                    <input type="text" required v-model="creditCardZip" placeholder="80525"
                    v-on:input="emitValues()"
                    v-on:blur="emitValues()" />
                </div>
            </div>
            <div class="row" v-if="field.typeSettings.receiptEmail===1">
                <div class="col col-lg-12">
                    <div class="credit-card-label" v-if="!field.label.hidden"><label>
                        <span>Receipt Email</span>
                        <span class="required">*</span>
                    </label></div>
                    <input type="text" required :value="receiptEmail" placeholder="Receipt Email"
                    v-on:input="addReceiptEmail($event.target.value)"
                    v-on:blur="addReceiptEmail($event.target.value)" />
                </div>
            </div>
        </div>
        <div v-if="!cardLoaded" class="card-progress-bar"></div>
    </div>
</template>

<script>
  import { mapState, mapMutations, mapGetters } from 'vuex';
  import axios from 'axios';
  import formMixin from '../../mixins/formMixin';
  import paymentsMixin from '../../mixins/paymentsMixin';
  import ErrorMessage from '../ErrorMessage';

  export default {
    mixins: [paymentsMixin, formMixin],
    props: {
        field: null,
        min: 0,
        defaultQuantity: {},
        disableQuantity: 0,
    },
    data() {
        return {
            unwatchName: null,
            unwatchEmail: null,
            nameFromResponse: '',
            emailFromResponse: '',
            creditCardName: null,
            creditCardZip: '',
            creditCardEmail: null,
            errors: {
                card: '',
                date: '',
                cvc: ''
            },
        };
    },
    methods: {
        ...mapMutations('payments', {
            setStripe: 'setStripe',
            setStripeElements: 'setStripeElements',
            setPaymentRequired: 'setPaymentRequired',
            setCardLoaded: 'setCardLoaded'
        }),
        watchNameResponse() {
            this.unwatchName = this.$watch('response', function () {
              let response = this.$store.state.response;
              let nameVals = this.ccNameFieldIds.map(id => {
                  if (response[id]) {
                      return response[id].value;
                  }
              }).filter(val => val);
              let newName = nameVals.join(' ');
              let oldName = this.nameFromResponse;
              this.nameFromResponse = newName;
              if (newName != oldName) {
                  this.emitValues();
              }
            }, {deep: true});
        },
        watchEmailResponse() {
            this.unwatchEmail = this.$watch('response', function () {
              let response = this.$store.state.response;
              let newEmail = response[this.ccEmailFieldId] ? response[this.ccEmailFieldId].value : '';
              let oldEmail = this.emailFromResponse;
              this.emailFromResponse = newEmail;
              if (newEmail != oldEmail) {
                  this.emitValues();
              }
            }, {deep: true});
        },
        addCardHolderName(value) {
            if (this.unwatchName !== null) {
                this.unwatchName();
                this.unwatchName = null;
            }
            this.creditCardName = value;
            this.emitValues();
        },
        addReceiptEmail(value) {
            if (this.unwatchEmail !== null) {
                this.unwatchEmail();
                this.unwatchEmail = null;
            }
            this.creditCardEmail = value;
            this.emitValues();
        },
        emitValues() {
            var values = {
                name: this.cardholderName,
                zip: this.creditCardZip,
                email: this.receiptEmail
            };
            this.$emit('filled-out', values);
        },
        elementError(element, message, self) {
            let emit = false;
            if (message) {
                if (!self.errors[element] || self.errors[element] != message) {
                    emit = true;
                    self.errors[element] = message;
                }
            } else if (self.errors[element]) {
                self.errors[element] = '';
                emit = true;
            }
            return emit;
        },
        mountStripe() {
            let stripeScript = document.createElement('script');
            stripeScript.setAttribute('src', 'https://js.stripe.com/v3/');
            stripeScript.async = false;
            document.head.appendChild(stripeScript);
            stripeScript.addEventListener('load', () => {
                this.loadStripeElements();
            });
        },
        loadStripeElements() {
            var self = this;
            this.getPublishingKey().then(function(data) {
                self.setStripe(Stripe(data.key, {stripeAccount: data.accountId}));
                self.setStripeElements(self.stripe.base.elements());
                self.setCardLoaded();

                var styles = {
                    base : {
                        color: '#24282f',
                        fontWeight: 'normal',
                        fontFamily: "SFProDisplay,'Avenir', Helvetica, Arial, sans-serif",
                        fontSize: '14px',
                        fontSmoothing: 'antialiased',
                        backgroundColor: '#fff',
                    }
                };

                var cardNumber = self.stripe.elements.create('cardNumber', {
                    iconStyle: 'solid',
                    style: styles
                });
                cardNumber.on('change', function (e) {
                    self.stripe.cardEmpty = e.empty;
                    if (self.elementError('card', e.error ? e.error.message : '', self) === true) {
                        self.$emit('error', self.emittedErrorMessage);
                    }
                });
                cardNumber.mount('#card-number');

                var cardExpiry = self.stripe.elements.create('cardExpiry', {
                    style: styles
                });
                cardExpiry.on('change', function (e) {
                    self.stripe.dateEmpty = e.empty;
                    if (self.elementError('date', e.error ? e.error.message : '', self) === true) {
                        self.$emit('error', self.emittedErrorMessage);
                    }
                });
                cardExpiry.mount('#card-expiry');

                var cardCvc = self.stripe.elements.create('cardCvc', {
                    style: styles
                });
                cardCvc.on('change', function (e) {
                    self.stripe.cvcEmpty = e.empty;
                    if (self.elementError('cvc', e.error ? e.error.message : '', self) === true) {
                        self.$emit('error', self.emittedErrorMessage);
                    }
                });
                cardCvc.mount('#card-cvc');
            });
        },
        async getPublishingKey() {
            var response;
            let body = {params: {fieldId: this.field.id}};
            response = await axios.get(`${this.domain}/forms/api/v1/forms/${this.field.formId}/integrations/payments/creditcard/publishing-key`, body);
            return response.data ? response.data : '';
        }
    },
    computed: {
        ...mapState('form', {
            form: 'form',
            stripe: 'stripe',
            cardLoaded: 'cardLoaded'
        }),
        ...mapState(['response']),
        ...mapState('payments', { stripe: 'stripe', cardLoaded: 'cardLoaded' }),
        ...mapGetters('form', [
          'nameFieldIds',
          'fieldByType',
          'domain'
        ]),
        loadedStyle() {
            return {
                display: this.cardLoaded ? 'block' : 'none'
            };
        },
        emittedErrorMessage() {
            let errorsCount = Object.values(this.errors).filter(value => value != '').length;
            if (errorsCount > 0) {
                return 'Please double check your input.';
            } else {
                return '';
            }
        },
        cardholderName() {
            return this.creditCardName === null ? this.nameFromResponse : this.creditCardName;
        },
        receiptEmail() {
            return this.creditCardEmail === null ? this.emailFromResponse : this.creditCardEmail;
        },
        ccNameFieldIds() {
            return this.field.typeSettings.cardholderName === 1 ? this.nameFieldIds : [this.field.typeSettings.cardholderName];
        },
        ccEmailFieldId() {
            return this.field.typeSettings.receiptEmail === 1 ? this.fieldByType('email').id : this.field.typeSettings.receiptEmail;
        }
    },
    created() {
        this.setPaymentRequired(true);
    },
    mounted() {
        this.watchNameResponse();
        this.watchEmailResponse();
        this.mountStripe();
    },
    components: {
      ErrorMessage,
    },
  };
</script>
<style>
.payments-credit-card {
    font-size: 14px;
}
.payments-credit-card.form-control {
    height: auto;
    padding:0;
    border: 0;
}
.payments-credit-card input {
    margin-top: 0;
    padding: 1rem;
    margin-bottom: 1rem;
    width: 100%;
}
.payments-credit-card .credit-card-input {
    background-color: #fff;
    border: solid 1px #dddedf;
    border-radius: 5px;
    height: 48px;
    padding: 1rem;
    margin-bottom: 1.1rem;
}
.card-progress-bar {
    background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
    background-size: 1rem 1rem;
    animation: progress-bar-stripes 1s linear infinite;
    transition: width .6s ease;
    background-color: #ccc;
    height: 16px;
    width: 100%;
}
.creditcard-field-wrapper .payments-credit-card .invalid-input {
    display:block;
    margin-top:-.9rem;
    font-size:13px;
}
</style>
